import React from 'react';

export default function FwPriceIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-dollar-sign' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}